import { Injectable } from '@angular/core';

import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { FileSystemsActions } from '../actions';
import { DialogOpen } from '../../../application-state/store/actions/dialog.actions';
import { ModalDialogOptions } from '../../../application-state/models';
import { NotifierService } from 'angular-notifier';
import { FileSystemsService } from '../../services/file-systems.service';

@Injectable()
export class FileSystemsEffects {
  CreateFileSystem$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FileSystemsActions.CreateFileSystem),
      switchMap(({ payload }) => {
        return this.service.createFileSystem(payload).pipe(
          map(response =>
            FileSystemsActions.CreateFileSystemSuccess({ response })
          ),
          catchError(response =>
            of(FileSystemsActions.CreateFileSystemFail({ response }))
          )
        );
      })
    )
  );
  ReadFileSystem$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FileSystemsActions.ReadFileSystem),
      switchMap(({ iri }) => {
        return this.service.getFileSystem(iri).pipe(
          map(response =>
            FileSystemsActions.ReadFileSystemSuccess({ response })
          ),
          catchError(response =>
            of(FileSystemsActions.ReadFileSystemFail({ response }))
          )
        );
      })
    )
  );
  ReadFileSystems$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FileSystemsActions.ReadFileSystems),
      switchMap(() => {
        return this.service.getFileSystems().pipe(
          map(response =>
            FileSystemsActions.ReadFileSystemsSuccess({ response })
          ),
          catchError(response =>
            of(FileSystemsActions.ReadFileSystemsFail({ response }))
          )
        );
      })
    )
  );
  UpdateFileSystem$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FileSystemsActions.UpdateFileSystem),
      switchMap(payload => {
        return this.service.updateFileSystem(payload).pipe(
          map(response =>
            FileSystemsActions.UpdateFileSystemSuccess({ response })
          ),
          catchError(response =>
            of(FileSystemsActions.UpdateFileSystemFail({ response }))
          )
        );
      })
    )
  );
  DeleteFileSystem$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FileSystemsActions.DeleteFileSystem),
      switchMap(({ iri }) => {
        return this.service.deleteFileSystem(iri).pipe(
          map(() => FileSystemsActions.DeleteFileSystemSuccess({ iri })),
          catchError(response =>
            of(FileSystemsActions.DeleteFileSystemFail({ response }))
          )
        );
      })
    )
  );
  FailActions = createEffect(
    () =>
      this.actions$.pipe(
        ofType(
          FileSystemsActions.DeleteFileSystemFail,
          FileSystemsActions.UpdateFileSystemFail,
          FileSystemsActions.ReadFileSystemsFail,
          FileSystemsActions.ReadFileSystemFail,
          FileSystemsActions.CreateFileSystemFail
        ),
        map(({ type, response }) => {
          console.log({ response });
          const errors = response?.error['hydra:description'];
          const message = 'Fehler bei der Anfrage: ' + errors;
          this.notifierService.show({ type: 'error', message });
        })
      ),
    { dispatch: false }
  );
  fileSystemActionSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        FileSystemsActions.CreateFileSystemSuccess,
        FileSystemsActions.UpdateFileSystemSuccess
      ),
      map(({ type }) => {
        const text =
          type === FileSystemsActions.CREATE_FILE_SYSTEM_SUCCESS
            ? 'Eine neues Dateisystem wurde angelegt.'
            : 'Das Dateisystem wurde aktualisiert.';

        const payload: ModalDialogOptions = {
          config: {
            data: {
              heading: 'Das hat geklappt',
              text,
              cancelText: 'OK'
            }
          }
        };
        return DialogOpen({ payload });
      })
    )
  );

  constructor(
    private actions$: Actions,
    private service: FileSystemsService,
    private notifierService: NotifierService
  ) {}
}
